import { fetchSection } from '../actions/section';
import { selectSection } from '../selectors/section';

export function sectionsResource(options, section_ids) {
    return {
        id: `/sections/${section_ids.join(':')}`,
        load() {
            return Promise.all(
                section_ids.map(s => options.dispatch(fetchSection(s)))
            );
        },
        find() {
            return section_ids.map(id => selectSection(options.rootState, id));
        },
    };
}



// WEBPACK FOOTER //
// ./src/resources/sections.js